import * as React from 'react';
import type { SVGProps } from 'react';

const IconCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 8" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.25 1.356 3.547 7.354.25 4.404l.69-.77 2.607 2.332L9.56.586l.69.77Z"
      fill="currentColor"
    />
  </svg>
);
export default IconCheckmark;
